
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-relight",
      function () {
        return require("private-next-pages/ai-relight/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-relight"])
      });
    }
  